import { decodeJWT } from './utils';
import cookie from 'cookie';
import Cookies from 'js-cookie';
import { UserTokenResponse } from '../../types/authentication';

const getJwtToken = async (cookies: any) => {
  const hussleDomain = process.env.NEXT_PUBLIC_HUSSLE_DOMAIN;
  return fetch(`${hussleDomain}/jwt`, { credentials: 'include', headers: { cookie: cookies } }).then(
    async (responseCall) => {
      if (responseCall.status !== 200) {
        return false;
      }
      const res = await responseCall.json();
      return res.datas.accessToken;
    },
  );
};

export const getUser: (cookies: any) => Promise<UserTokenResponse> = async (cookies: any) => {
  const { token } = cookie.parse(cookies);
  let accessToken = token;
  const response = {
    token,
    user: undefined,
  };
  if (!token) {
    accessToken = await getJwtToken(cookies);
    if (accessToken) {
      Object.assign(response, { token: accessToken });

      const in59Minutes = new Date(new Date().getTime() + 59 * 60 * 1000);
      Cookies.set('token', accessToken, {
        expires: in59Minutes,
        secure: true,
        sameSite: 'strict',
        /**
         * Static pages generate a new token on demand (expired/new).
         * Additionally, public-api requires an auth token.
         * As such we cannot restrict the client to access to this cookie with `httpOnly`
         *
         * httpOnly: true,
         */
      });
    }
  }

  const decodedData = decodeJWT(response.token);

  if (!decodedData) return response;

  const isLoggedIn = parseInt(decodedData.memberId) > 0;

  if (isLoggedIn) {
    Object.assign(response, { token: accessToken, user: decodedData });
  } else {
    Object.assign(response, { token: accessToken });
  }

  return response;
};
